export function getRecursiveOrganizations({ organization, childOrganizations }, organizationsList) {
  if (childOrganizations) {
    const items = childOrganizations.map((childOrganizationItem) => getRecursiveOrganizations(
      childOrganizationItem, 
      [...organizationsList, organization]
    ));

    return items.flat(); 
  }

  return [...organizationsList, organization];
}

export function getAllOrganizationsChildren({ organization, childOrganizations }) {
  const organizationsList = [];

  if (childOrganizations) {
    childOrganizations.forEach((childOrganizationItem) => {
      const { 
        organization: childOrganization, 
        childOrganizations: childOrganizationChildrens 
      } = childOrganizationItem;
      
      if (childOrganizationChildrens) {
        const organizationsRecursivelyList = getRecursiveOrganizations(childOrganizationItem, []);

        organizationsRecursivelyList.forEach(orgItem => {
          organizationsList.push(orgItem);
        });
      } else {
        organizationsList.push(childOrganization);
      }
    });
  }

  organizationsList.push(organization);

  return organizationsList;
}

export function stringsMatchToSearch(stringsList, search) {
  const parsedStringsList = stringsList.map(item => item.toLowerCase())

  return parsedStringsList.some(text => text.includes(search.toLowerCase()));
}

export function removeDuplicates(array) {
  return [...new Set(array)];
}

export function getOrganizationsIds(organizationsList) {
  return organizationsList.map(org => org.id);
}